import React from 'react';
import { RegularButton, Skeleton, type RegularButtonSize } from 'fronton-react';
import { useTranslation } from 'react-i18next';
import { css, cx } from 'linaria';

export const SponsoredProductCartButton: React.FC<{
  className?: string;
  size?: RegularButtonSize;
  isLoading: boolean;
  onClick: () => void;
}> = ({ className, isLoading, size = 'm', onClick }) => {
  const { t } = useTranslation();

  const content = (
    <RegularButton
      data-qa="product-cart-button"
      className={cx(className, mobileStyle)}
      onClick={onClick}
      aria-label={t('ui.aria-label.add-to-cart')}
      size={size}
      variant="primary"
      wide
    >
      {t('ui.button.add-to-cart')}
    </RegularButton>
  );

  return isLoading ? (
    <Skeleton width="100%" variant="control">
      {content}
    </Skeleton>
  ) : (
    content
  );
};

const mobileStyle = css`
  @media (--to-desktop) {
    width: 100%;
  }
`;
